module.exports = __webpack_public_path__ + "static/media/dashDesktop.717da45d.mp4";